var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0,
    strokeMiterlimit: 10,
    fill: "#5a5a5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.887 254.307a22.413 22.413 0 01-15.897-6.584c-8.78-8.781-8.78-23.011 0-31.793L215.93 7.99c8.782-8.778 23.012-8.778 31.793 0 8.778 8.779 8.778 23.012 0 31.79L39.783 247.72a22.404 22.404 0 01-15.896 6.587z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.827 254.307a22.408 22.408 0 01-15.897-6.584L7.99 39.783c-8.78-8.779-8.78-23.011 0-31.79 8.779-8.778 23.012-8.778 31.79 0l207.94 207.94c8.778 8.781 8.778 23.011 0 31.793a22.405 22.405 0 01-15.893 6.58z"
  }))));
}
export default SvgX;